import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "query",
    "option",
    "chip",
    "input",
    "results",
    "selectedList",
    "count",
    "empty",
    "hint",
    "selectedEmpty"
  ]

  connect() {
    this.refresh()
  }

  filter() {
    this.refresh()
  }

  add(event) {
    const sportId = event.currentTarget.dataset.sportId
    this.setSelected(sportId, true)
    this.queryTarget.value = ""
    this.refresh()
    this.queryTarget.focus()
  }

  remove(event) {
    this.setSelected(event.currentTarget.dataset.sportId, false)
    this.refresh()
  }

  clear() {
    this.selectedIds().forEach((sportId) => this.setSelected(sportId, false))
    this.refresh()
  }

  refresh() {
    const query = this.normalizedQuery()
    const hasQuery = query.length > 0
    let visibleOptions = 0

    this.optionTargets.forEach((option) => {
      const sportId = option.dataset.sportId
      const selected = this.isSelected(sportId)
      const matches = hasQuery && this.normalize(option.dataset.sportName).includes(query)
      const shouldShow = matches && !selected

      option.classList.toggle("d-none", !shouldShow)
      if (shouldShow) visibleOptions += 1
    })

    this.chipTargets.forEach((chip) => {
      chip.classList.toggle("d-none", !this.isSelected(chip.dataset.sportId))
    })

    const selectedCount = this.selectedIds().length

    if (this.hasCountTarget) {
      this.countTarget.textContent =
        `${selectedCount} ${selectedCount === 1 ? "modalidade selecionada" : "modalidades selecionadas"}`
    }

    if (this.hasHintTarget) {
      this.hintTarget.classList.toggle("d-none", hasQuery)
    }

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("d-none", !hasQuery || visibleOptions > 0)
    }

    if (this.hasSelectedEmptyTarget) {
      this.selectedEmptyTarget.classList.toggle("d-none", selectedCount > 0)
    }
  }

  setSelected(sportId, selected) {
    this.inputTargets
      .filter((input) => input.dataset.sportId === sportId)
      .forEach((input) => {
        input.disabled = !selected
      })
  }

  isSelected(sportId) {
    return this.inputTargets.some((input) => input.dataset.sportId === sportId && !input.disabled)
  }

  selectedIds() {
    return this.inputTargets
      .filter((input) => !input.disabled)
      .map((input) => input.dataset.sportId)
  }

  normalizedQuery() {
    return this.normalize(this.hasQueryTarget ? this.queryTarget.value : "")
  }

  normalize(value) {
    return (value || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim()
  }
}
